import { Images } from '@/assets/images';
import { PageTypeEnum, REGEX } from '@/constant';
import { cls, dayjs, formatDate } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	employerName: '',
	employerBirthDate: '',
	content: '',
	penaltyPoints: '',
	cumulativeTotal: '',
	registDate: '',
	headOfDepartment: '',
	employerSignature: '',
	employerPhone: '',
	registrantAffiliated: '',
	registrantPosition: '',
	registrantName: '',
	registrantSignature: '',
	registrantPhone: '',
};

type IValues = typeof initializeValue;

export const EMPLOYER_CERTIFICATE_OF_VIOLATION_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '고용주 별점 부과 확인서',
	mapPropToValues({ refTableName, detailData, franchiseData }) {
		if (refTableName === PageTypeEnum.FRANCHISE) {
			const unitInfo = detailData?.unitInfo;
			const adminInfo = detailData?.adminInfo;

			return {
				employerName: franchiseData?.employerName || '',
				employerBirthDate: franchiseData?.employerBirthDate || '',
				employerPhone: franchiseData?.employerPhone || '',

				registrantAffiliated: unitInfo?.name || '',
				registrantPosition:
					(adminInfo?.isWorkerMasterRole
						? unitInfo?.name
						: adminInfo?.departmentName) || '',
				registrantName: unitInfo?.managerName || '',
				registrantPhone: unitInfo?.managerPhone || '',

				registDate: formatDate(dayjs()),
			};
		}
		return {};
	},
	pages: [
		{
			background: {
				src: Images.formEmployerCertificateOfViolationHighlight,
				className: 'template',
				dataSource: Images.formEmployerCertificateOfViolation,
			},
			textAreas: [
				{
					name: 'employerName',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[166px] left-[178px] w-[264px]',
					maxLength: 16,
				},
				(values, index) => ({
					name: 'content',
					maxHeight: 320,
					className: 'text-base',
					containerClassName: cls(
						'absolute top-[200px] left-[178px] w-[520px]',
						values?.content && 'bg-white'
					),
					maxLength: 500,
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'penaltyPoints',
					maxHeight: 24,
					maxLength: 4,
					className: 'text-base',
					containerClassName: cls(
						'absolute top-[523px] left-[267px] w-[45px]',
						values?.penaltyPoints && 'bg-white'
					),
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'cumulativeTotal',
					maxHeight: 24,
					className: 'text-base',
					containerClassName: cls(
						'absolute top-[523px] left-[387px] w-[68px]',
						values?.cumulativeTotal && 'bg-white'
					),
					maxLength: 6,
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'headOfDepartment',
					maxHeight: 24,
					className: 'text-base text-right',
					containerClassName: cls(
						'absolute top-[754px] left-[82px] w-[205px]',
						values?.headOfDepartment && 'bg-white'
					),
					maxLength: 14,
					regex: REGEX.ALLOW_KR_SPACE,
				}),
				{
					name: 'employerName',
					maxHeight: 40,
					className: 'text-base leading-5',
					containerClassName: 'absolute top-[837px] left-[178px] w-[120px]',
					maxLength: 16,
				},
				{
					name: 'employerPhone',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[846px] left-[533px] w-[160px]',
					maxLength: 14,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'registrantAffiliated',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[896px] left-[248px] w-[195px]',
					maxLength: 13,
				},
				{
					name: 'registrantPosition',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[896px] left-[533px] w-[160px]',
					maxLength: 11,
				},
				{
					name: 'registrantName',
					maxHeight: 40,
					className: 'text-base leading-5',
					containerClassName: 'absolute top-[927px] left-[248px] w-[122px]',
					maxLength: 16,
				},
				{
					name: 'registrantPhone',
					maxHeight: 20,
					className: 'text-base',
					containerClassName: 'absolute top-[934px] left-[533px] w-[160px]',
					maxLength: 14,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
			],
			datePickers: [
				{
					name: 'employerBirthDate',
					className:
						'[&>.ant-picker-input>input]:!text-base [&>.ant-picker-input>input]:!w-[160px] [&>.ant-picker-input>input]:text-center',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[164px] left-[533px]',
				},
				{
					name: 'registDate',
					segmentedInputs: true,
					style: { fontSize: '16px' },
					format: 'YY   MM   DD',
					containerClassName: 'absolute top-[728px] left-[358px]',
				},
			],
			signatures: [
				{
					name: 'employerSignature',
					className: 'absolute w-[140px] h-[38px] top-[837px] left-[305px]',
				},
				{
					name: 'registrantSignature',
					className: 'absolute w-[70px] h-[36px] top-[928px] left-[375px]',
				},
			],
		},
	],
};
